import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

export default function Home() {
  return (
    <div className="home-container">
      <div className="glow-orb" />
      <div className="glow-orb-secondary" />
      
      <div className="home-content">
        <Link to="/about" className="about-btn">
          About Us
        </Link>

        <h1 className="brand-title">
          <span className="brand-app">APP</span>
          <span className="brand-core">CORE</span>
          <span className="brand-labs">LABS</span>
        </h1>

        <p className="tagline">Crafting premium mobile experiences</p>

        <a href="mailto:hello@appcorelab.co" className="email-link">
          hello@appcorelab.co
        </a>
      </div>

      <div className="floating-shapes">
        <div className="shape shape-1" />
        <div className="shape shape-2" />
        <div className="shape shape-3" />
      </div>
    </div>
  );
}